export default __webpack_public_path__ + "static/media/4.fe7d1503.jpg";